import axios from "axios";

const inviteVideoCallWithGsmNo = async (baseUrl, token, doctorId, appointment, mobilePhone) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.post(baseUrl + "/doctor/" + doctorId + "/appointment/" + appointment + "/invite/" + mobilePhone, {}, config)
        .then((res) => {
            putResponse = {
                status: res.data.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return putResponse
}

export default inviteVideoCallWithGsmNo;